// 小米负一屏小部件
export default {
  // 英语域名
  "en-wg.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 印地语域名
  "hi-wg.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],

    "300x250": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 印尼语域名
  "id-wg.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 西班牙语域名
  "es-wg.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
};
